import { useEffect, useRef, useState } from 'react';

import { useDynamicFontSize } from 'hooks/useDynamicFontSize';

import RoundedRow from './RoundedRow';

type EventNameRowProps = {
  sourceName: string;
};

const EventNameRow = ({ sourceName }: EventNameRowProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number>(0);

  const getValue = (value: string) => {
    if (!value) return '-';
    return value;
  };

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const fontSize = useDynamicFontSize({
    text: getValue(sourceName),
    containerWidth,
    maxLines: 2,
    lineHeight: 1.2,
    verticalPadding: 5,
    minFontSize: 6,
    fontWeight: 'bold',
  });

  return (
    <RoundedRow>
      <div
        ref={containerRef}
        className="tw-px-[10px] tw-py-[5px] tw-text-center"
        style={{ overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className="tw-line-clamp-2 tw-font-bold tw-text-white"
          style={{ fontSize: `${fontSize}px`, lineHeight: 1.2 }}
        >
          {getValue(sourceName)}
        </div>
      </div>
    </RoundedRow>
  );
};

export default EventNameRow;
